import React, { useState } from 'react';
import { Card, Button, Image } from 'react-bootstrap';
import CommentSection from './CommentSection';
import { RiShareForwardFill } from 'react-icons/ri';
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import ShareModel from '../../../components/Sharemodel';
import ShareOption from "../../../components/Shareoption";
import {images} from "../../../constants/index";

const TimelineCard = () => {
  const [liked, setLiked] = useState(false);
  const [showComments, setShowComments] = useState(false);
   const [showmodal, setShowmodal] = useState(false);
  const handleClosemodal = () => setShowmodal(false);
 

  const [showshare, setShowshare] = useState(false);
  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };
  const handleShowshare = () => setShowshare(true);

  return (
    <Card className="mb-3">

      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      
      <ShareModel
        showmodal={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
        
      />
      
      <Card.Body>
        <div className="d-flex align-items-center mb-2">
          <Image src="https://i.pravatar.cc/40" roundedCircle className="me-2" />
          <div>
            <strong>Kap Clothing</strong>
            <div style={{ fontSize: 12 }}>Garment Retailer</div>
          </div>
        </div>

        <Card.Title>How to Manage Time for traveling</Card.Title>
        <Card.Text style={{ fontSize: 14, color: "#666" }}>
          Lorem ipsum dolor sit amet, consectetur adi tempor incididunt...
        </Card.Text>

        <Card.Img variant="bottom" src="https://images.unsplash.com/photo-1523413651479-597eb2da0ad6" />

<div className="d-flex justify-content-between font-sm mt-1">
        <div>
          <div style={{ display: "flex", cursor: "pointer" }}>
            <p className="pe-2 mb-0"> Like</p>
          </div>
        </div>
        <div>
          <div style={{ display: "flex", cursor: "pointer" }}>
            <p className="mb-0"> Dislike</p>
          </div>
        </div>
        <div>
          <p className="pe-3 mb-0">44 Comments</p>
        </div>
        <div>
          <p className="mb-0">6 Shares</p>
        </div>
      </div>






            <div className="d-flex justify-content-between font-sm mt-2">
      <div
  className="d-flex align-items-center pt-1 pb-2 cursor_P"

>
 
    <img className="w-img" src={images.Liked} alt="image" />

</div>


<div
  className="d-flex align-items-center pt-1 pb-2 cursor_P"
 
>
 

    <img className="w-img" src={images.DisLiked} alt="image" />

</div>


        <div
          className="d-flex pt-1 cursor_P"
          onClick={() => {
          setShowComments(prev => !prev);
          }}
        >
          <ChatBubbleIcon sx={{ color: "#434343" }} />
          <p className="pe-2">Comment</p>
        </div>

        <div
          className="d-flex"
          onClick={() => {
           
            setShowmodal(true);
         
          }}
        >
          <RiShareForwardFill  size={24}  color="#434343"  />
          <p className="mt-1">Share</p>
        </div>
      </div>

        {showComments && <CommentSection />}
      </Card.Body>
    </Card>
  );
};

export default TimelineCard;
